<template>
  <config-provider :locale="locale">
    <div id="app">
      <router-view />
    </div>
  </config-provider>
</template>
<script>
import ConfigProvider from 'ant-design-vue/lib/config-provider'
import zhCN from 'ant-design-vue/es/locale/zh_CN';
import enquireScreen from '@/utils/device'

export default {
  components: { ConfigProvider },
  data () {
    return {
      locale: zhCN,
    }
  },
  created () {
    let that = this
    enquireScreen(deviceType => {
      // tablet
      if (deviceType === 0) {
        that.$store.commit('TOGGLE_DEVICE', 'mobile')
        that.$store.dispatch('setSidebar', false)
      }
      // mobile
      else if (deviceType === 1) {
        that.$store.commit('TOGGLE_DEVICE', 'mobile')
        that.$store.dispatch('setSidebar', false)
      }
      else {
        that.$store.commit('TOGGLE_DEVICE', 'desktop')
        that.$store.dispatch('setSidebar', true)
      }

    })
  }
}
</script>
<style>
#app {
  height: 100%;
}
</style>